// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * MailChimp Campaign Details Enhanced Styles
 * Modern, user-friendly design with tabbed navigation and improved layout
 */

.campaign-details-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(15px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.campaign-details-modal {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(25px);
  border-radius: 24px;
  box-shadow:
    0 32px 64px rgba(0, 0, 0, 0.3),
    0 16px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  max-width: 95vw;
  width: 100%;
  max-height: 95vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* Enhanced Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 32px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
  border-radius: 24px 24px 0 0;
}

.header-content {
  flex: 1 1;
}

.campaign-title-section h2 {
  color: #2d3748;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.campaign-meta {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.campaign-id {
  color: #718096;
  font-size: 0.9rem;
  font-family: monospace;
  background: rgba(102, 126, 234, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
}

.status-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.save {
  background: rgba(59, 130, 246, 0.1);
  color: #3b82f6;
}

.status-badge.sent {
  background: rgba(34, 197, 94, 0.1);
  color: #22c55e;
}

.status-badge.sending {
  background: rgba(245, 158, 11, 0.1);
  color: #f59e0b;
}

.campaign-type {
  background: rgba(13, 59, 102, 0.1);
  color: #0D3B66;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: capitalize;
}

.close-button {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 1.8rem;
  color: #4a5568;
  cursor: pointer;
  padding: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  flex-shrink: 0;
}

.close-button:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.2);
  transform: scale(1.05);
}

/* Navigation Tabs */
.modal-navigation {
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 0 32px;
}

.tab-buttons {
  display: flex;
  gap: 4px;
  overflow-x: auto;
}

.tab-button {
  background: transparent;
  border: none;
  padding: 16px 24px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #718096;
  cursor: pointer;
  border-radius: 12px 12px 0 0;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-button:hover {
  background: rgba(102, 126, 234, 0.05);
  color: #4a5568;
}

.tab-button.active {
  background: rgba(13, 59, 102, 0.1);
  color: #0D3B66;
  font-weight: 600;
}

/* Modal Content */
.modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Loading Section */
.loading-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  gap: 16px;
}

.loading-section p {
  color: #718096;
  font-size: 1rem;
  margin: 0;
}

/* Overview Tab */
.overview-tab {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.metric-card {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.metric-card.primary {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 197, 253, 0.1) 100%);
  border-color: rgba(59, 130, 246, 0.2);
}

.metric-card.success {
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(134, 239, 172, 0.1) 100%);
  border-color: rgba(34, 197, 94, 0.2);
}

.metric-card.info {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(165, 180, 252, 0.1) 100%);
  border-color: rgba(102, 126, 234, 0.2);
}

.metric-card.warning {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(252, 211, 77, 0.1) 100%);
  border-color: rgba(245, 158, 11, 0.2);
}

.metric-icon {
  font-size: 2rem;
  opacity: 0.8;
}

.metric-content h3 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-value {
  color: #2d3748;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

.metric-detail {
  color: #718096;
  font-size: 0.8rem;
  margin: 4px 0 0 0;
}

/* Campaign Summary */
.campaign-summary {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.campaign-summary h3 {
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-item label {
  color: #718096;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-item span {
  color: #2d3748;
  font-size: 0.9rem;
  font-weight: 500;
}

.summary-item a {
  color: #0D3B66;
  text-decoration: none;
  font-weight: 500;
}

.summary-item a:hover {
  text-decoration: underline;
}

/* Details Tab */
.details-tab {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.search-section {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.search-box {
  position: relative;
  max-width: 400px;
}

.search-input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  background: white;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #718096;
  font-size: 1rem;
}

.details-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.category-section {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.category-title {
  color: #2d3748;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.fields-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
}

.field-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: rgba(102, 126, 234, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(102, 126, 234, 0.1);
}

.field-label {
  color: #4a5568;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.field-value {
  color: #2d3748;
  font-size: 0.9rem;
  font-weight: 500;
  word-break: break-word;
}

.field-value.percentage {
  color: #22c55e;
  font-weight: 600;
}

.field-value.number {
  color: #3b82f6;
  font-weight: 600;
}

.field-value.currency {
  color: #f59e0b;
  font-weight: 600;
}

.field-value.boolean {
  color: #8b5cf6;
  font-weight: 600;
}

/* Analytics Tab */
.analytics-tab {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.analytics-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.analytics-section {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.analytics-section h3 {
  color: #2d3748;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 20px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.metrics-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.metric-card h4 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.metric-number {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 4px 0;
}

.metric-rate {
  color: #718096;
  font-size: 0.8rem;
  margin: 0;
}

.comparison-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.comparison-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: rgba(102, 126, 234, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(102, 126, 234, 0.1);
}

.comparison-item label {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 500;
}

.your-rate {
  color: #22c55e;
  font-size: 1.1rem;
  font-weight: 700;
}

.industry-rate {
  color: #3b82f6;
  font-size: 1.1rem;
  font-weight: 700;
}

/* Timeseries Tab */
.timeseries-tab {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.timeseries-header {
  text-align: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.timeseries-header h3 {
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.timeseries-header p {
  color: #718096;
  font-size: 0.9rem;
  margin: 0;
}

.timeseries-table-container {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow-x: auto;
}

.timeseries-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.timeseries-table th {
  background: rgba(102, 126, 234, 0.1);
  color: #2d3748;
  font-weight: 600;
  padding: 16px;
  text-align: left;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.timeseries-table td {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  color: #4a5568;
  font-size: 0.9rem;
}

.timeseries-table tr:hover {
  background: rgba(102, 126, 234, 0.05);
}

/* Modal Actions */
.modal-actions {
  display: flex;
  gap: 12px;
  padding: 24px 32px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0 0 24px 24px;
  justify-content: flex-end;
}

.btn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
}

.btn-outline {
  background: transparent;
  color: #4a5568;
  border-color: #e2e8f0;
}

.btn-outline:hover {
  background: rgba(102, 126, 234, 0.05);
  border-color: #0D3B66;
  color: #0D3B66;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
  border-color: #0D3B66;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .campaign-details-modal {
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }

  .modal-header {
    padding: 20px;
  }

  .modal-content {
    padding: 20px;
  }

  .modal-actions {
    padding: 20px;
    flex-direction: column;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
  }

  .summary-grid {
    grid-template-columns: 1fr;
  }

  .fields-grid {
    grid-template-columns: 1fr;
  }

  .tab-buttons {
    overflow-x: auto;
    padding-bottom: 8px;
  }

  .campaign-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .campaign-details-overlay {
    padding: 10px;
  }

  .modal-header {
    padding: 16px;
  }

  .modal-content {
    padding: 16px;
  }

  .modal-actions {
    padding: 16px;
  }

  .campaign-title-section h2 {
    font-size: 1.4rem;
  }

  .metric-card {
    padding: 16px;
  }

  .metric-value {
    font-size: 1.4rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/mailchimp/MailChimpCampaignDetails.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;EAC1C,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,iDAAiD;EACjD,gGAAgG;EAChG,4BAA4B;AAC9B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,8FAA8F;EAC9F,qCAAqC;AACvC;;AAEA;EACE,6FAA6F;EAC7F,oCAAoC;AACtC;;AAEA;EACE,+FAA+F;EAC/F,sCAAsC;AACxC;;AAEA;EACE,6FAA6F;EAC7F,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,qCAAqC;EACrC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/**\n * MailChimp Campaign Details Enhanced Styles\n * Modern, user-friendly design with tabbed navigation and improved layout\n */\n\n.campaign-details-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(15px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.campaign-details-modal {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(25px);\n  border-radius: 24px;\n  box-shadow:\n    0 32px 64px rgba(0, 0, 0, 0.3),\n    0 16px 32px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  max-width: 95vw;\n  width: 100%;\n  max-height: 95vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n/* Enhanced Header */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 32px;\n  border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);\n  border-radius: 24px 24px 0 0;\n}\n\n.header-content {\n  flex: 1;\n}\n\n.campaign-title-section h2 {\n  color: #2d3748;\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0 0 12px 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.campaign-meta {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.campaign-id {\n  color: #718096;\n  font-size: 0.9rem;\n  font-family: monospace;\n  background: rgba(102, 126, 234, 0.1);\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.save {\n  background: rgba(59, 130, 246, 0.1);\n  color: #3b82f6;\n}\n\n.status-badge.sent {\n  background: rgba(34, 197, 94, 0.1);\n  color: #22c55e;\n}\n\n.status-badge.sending {\n  background: rgba(245, 158, 11, 0.1);\n  color: #f59e0b;\n}\n\n.campaign-type {\n  background: rgba(13, 59, 102, 0.1);\n  color: #0D3B66;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.close-button {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  font-size: 1.8rem;\n  color: #4a5568;\n  cursor: pointer;\n  padding: 0;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  flex-shrink: 0;\n}\n\n.close-button:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  border-color: rgba(239, 68, 68, 0.2);\n  transform: scale(1.05);\n}\n\n/* Navigation Tabs */\n.modal-navigation {\n  background: rgba(255, 255, 255, 0.95);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  padding: 0 32px;\n}\n\n.tab-buttons {\n  display: flex;\n  gap: 4px;\n  overflow-x: auto;\n}\n\n.tab-button {\n  background: transparent;\n  border: none;\n  padding: 16px 24px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #718096;\n  cursor: pointer;\n  border-radius: 12px 12px 0 0;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tab-button:hover {\n  background: rgba(102, 126, 234, 0.05);\n  color: #4a5568;\n}\n\n.tab-button.active {\n  background: rgba(13, 59, 102, 0.1);\n  color: #0D3B66;\n  font-weight: 600;\n}\n\n/* Modal Content */\n.modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Loading Section */\n.loading-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  gap: 16px;\n}\n\n.loading-section p {\n  color: #718096;\n  font-size: 1rem;\n  margin: 0;\n}\n\n/* Overview Tab */\n.overview-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.metric-card {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.metric-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n.metric-card.primary {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 197, 253, 0.1) 100%);\n  border-color: rgba(59, 130, 246, 0.2);\n}\n\n.metric-card.success {\n  background: linear-gradient(135deg, rgba(34, 197, 94, 0.1) 0%, rgba(134, 239, 172, 0.1) 100%);\n  border-color: rgba(34, 197, 94, 0.2);\n}\n\n.metric-card.info {\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(165, 180, 252, 0.1) 100%);\n  border-color: rgba(102, 126, 234, 0.2);\n}\n\n.metric-card.warning {\n  background: linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(252, 211, 77, 0.1) 100%);\n  border-color: rgba(245, 158, 11, 0.2);\n}\n\n.metric-icon {\n  font-size: 2rem;\n  opacity: 0.8;\n}\n\n.metric-content h3 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.metric-value {\n  color: #2d3748;\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.metric-detail {\n  color: #718096;\n  font-size: 0.8rem;\n  margin: 4px 0 0 0;\n}\n\n/* Campaign Summary */\n.campaign-summary {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.campaign-summary h3 {\n  color: #2d3748;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 16px;\n}\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.summary-item label {\n  color: #718096;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.summary-item span {\n  color: #2d3748;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.summary-item a {\n  color: #0D3B66;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.summary-item a:hover {\n  text-decoration: underline;\n}\n\n/* Details Tab */\n.details-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.search-section {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.search-box {\n  position: relative;\n  max-width: 400px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 16px 12px 40px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  background: white;\n  transition: all 0.3s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #718096;\n  font-size: 1rem;\n}\n\n.details-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.category-section {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.category-title {\n  color: #2d3748;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  padding-bottom: 12px;\n  border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n}\n\n.fields-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 16px;\n}\n\n.field-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  background: rgba(102, 126, 234, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(102, 126, 234, 0.1);\n}\n\n.field-label {\n  color: #4a5568;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.field-value {\n  color: #2d3748;\n  font-size: 0.9rem;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.field-value.percentage {\n  color: #22c55e;\n  font-weight: 600;\n}\n\n.field-value.number {\n  color: #3b82f6;\n  font-weight: 600;\n}\n\n.field-value.currency {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n.field-value.boolean {\n  color: #8b5cf6;\n  font-weight: 600;\n}\n\n/* Analytics Tab */\n.analytics-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.analytics-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.analytics-section {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  padding: 24px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.analytics-section h3 {\n  color: #2d3748;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.metrics-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.metric-card h4 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.metric-number {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0 0 4px 0;\n}\n\n.metric-rate {\n  color: #718096;\n  font-size: 0.8rem;\n  margin: 0;\n}\n\n.comparison-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n.comparison-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  background: rgba(102, 126, 234, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(102, 126, 234, 0.1);\n}\n\n.comparison-item label {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.your-rate {\n  color: #22c55e;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n.industry-rate {\n  color: #3b82f6;\n  font-size: 1.1rem;\n  font-weight: 700;\n}\n\n/* Timeseries Tab */\n.timeseries-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.timeseries-header {\n  text-align: center;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.timeseries-header h3 {\n  color: #2d3748;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.timeseries-header p {\n  color: #718096;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.timeseries-table-container {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  overflow-x: auto;\n}\n\n.timeseries-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n}\n\n.timeseries-table th {\n  background: rgba(102, 126, 234, 0.1);\n  color: #2d3748;\n  font-weight: 600;\n  padding: 16px;\n  text-align: left;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.timeseries-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  color: #4a5568;\n  font-size: 0.9rem;\n}\n\n.timeseries-table tr:hover {\n  background: rgba(102, 126, 234, 0.05);\n}\n\n/* Modal Actions */\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  padding: 24px 32px;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n  background: rgba(255, 255, 255, 0.95);\n  border-radius: 0 0 24px 24px;\n  justify-content: flex-end;\n}\n\n.btn {\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid transparent;\n}\n\n.btn-outline {\n  background: transparent;\n  color: #4a5568;\n  border-color: #e2e8f0;\n}\n\n.btn-outline:hover {\n  background: rgba(102, 126, 234, 0.05);\n  border-color: #0D3B66;\n  color: #0D3B66;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n  border-color: #0D3B66;\n}\n\n.btn-primary:hover {\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .campaign-details-modal {\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .modal-header {\n    padding: 20px;\n  }\n\n  .modal-content {\n    padding: 20px;\n  }\n\n  .modal-actions {\n    padding: 20px;\n    flex-direction: column;\n  }\n\n  .metrics-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .fields-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tab-buttons {\n    overflow-x: auto;\n    padding-bottom: 8px;\n  }\n\n  .campaign-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .campaign-details-overlay {\n    padding: 10px;\n  }\n\n  .modal-header {\n    padding: 16px;\n  }\n\n  .modal-content {\n    padding: 16px;\n  }\n\n  .modal-actions {\n    padding: 16px;\n  }\n\n  .campaign-title-section h2 {\n    font-size: 1.4rem;\n  }\n\n  .metric-card {\n    padding: 16px;\n  }\n\n  .metric-value {\n    font-size: 1.4rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
